/** Only browser instances have LocalModel; database wrappers must never loop back over HTTP. */
export function useServerLookup(aeppic, kind: 'controls' | 'designs' | 'navigation'): boolean {
  return aeppic.LocalModel != null
    && aeppic.Features?.isEnabled?.('server-lookup') === true
    && aeppic.Features?.getOptionsFor?.('server-lookup')?.[kind] !== false
}
